import { render, staticRenderFns } from "./ResumeVatInfo.vue?vue&type=template&id=b7743508"
import script from "./ResumeVatInfo.vue?vue&type=script&lang=ts"
export * from "./ResumeVatInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports